import { render, staticRenderFns } from "./Error-component.vue?vue&type=template&id=0091d56c&scoped=true&"
import script from "./Error-component.vue?vue&type=script&lang=js&"
export * from "./Error-component.vue?vue&type=script&lang=js&"
import style0 from "./Error-component.vue?vue&type=style&index=0&id=0091d56c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091d56c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
